import { userRoles } from "src/config/constants/genericConstants";
import { Permission } from "src/pages/Login/interface";

export const hasAccess = (permissions: any, name: string) => {
  return permissions?.some(
    (permission: Permission) => permission?.key === name
  );
};
export const hasAccessToPermissions = (
  masterData: Permission[],
  permission: string[]
) => {
  const hasAccessPemissions: { [key: string]: boolean } = {};
  for (const masterPermission of masterData) {
    if (masterPermission?.key && permission?.includes(masterPermission.key)) {
      hasAccessPemissions[masterPermission.key] = true;
    }
  }
  return hasAccessPemissions;
};

export const hasAllAccess = (permissions: any, name: string[]) => {
  const permissionsAllowed = name?.map((item) => {
    return permissions?.some(
      (permission: Permission) => permission?.key === item
    );
  });
  return permissionsAllowed?.every(Boolean);
};

export const isApproverUser = (role: string) =>
  role === userRoles.LU || role === userRoles.IA;

export const isIOUser = (role: string): boolean => role === userRoles.IO;

export const isIoOrUoUser = (role: string): boolean =>
  role === userRoles.IO || role === userRoles.UO;
